import { fromPollServer } from "./fromPollServer";
import { toCreatePollPayload, toPollServer } from "./toPollServer";
const BASE_URL = "/_serverless/polls-client/v1";
class PollsService {
  constructor(instance, getHttpClientPromise) {
    this.getHttpClientPromise = getHttpClientPromise;
    this.fetchData = (response) => response.data?.question || response.data;
    this.fetchPoll = async (pollId) => {
      const httpClient = await this.getHttpClientPromise();
      try {
        const response = await httpClient.get(`/questions/${pollId}`, this.requestOptions);
        return fromPollServer(response.data.question);
      } catch (e) {
        if (e?.response?.status === 404) {
          throw new Error("POLL_NOT_FOUND");
        }
        throw e;
      }
    };
    this.createPoll = async (question) => {
      const httpClient = await this.getHttpClientPromise();
      const response = await httpClient.post(
        `/questions`,
        {
          question: toCreatePollPayload(question)
        },
        this.requestOptions
      );
      return fromPollServer(response.data.question);
    };
    this.updatePoll = async (question) => {
      const httpClient = await this.getHttpClientPromise();
      try {
        const response = await httpClient.patch(
          `/questions/${question.id}`,
          {
            question: toPollServer(question)
          },
          this.requestOptions
        );
        return fromPollServer(response.data.question);
      } catch (e) {
        if (e?.response?.status === 404) {
          throw new Error("POLL_NOT_FOUND");
        }
        throw e;
      }
    };
    this.vote = async (pollId, optionId) => {
      const httpClient = await this.getHttpClientPromise();
      const response = await httpClient.post(
        `/questions/${pollId}/vote`,
        {
          optionId
        },
        this.requestOptions
      );
      return fromPollServer(response.data.question);
    };
    this.unvote = async (pollId, optionId) => {
      const httpClient = await this.getHttpClientPromise();
      const response = await httpClient.post(
        `/questions/${pollId}/unvote`,
        {
          optionId
        },
        this.requestOptions
      );
      return fromPollServer(response.data.question);
    };
    this.getVoters = async (pollId, optionId, params) => {
      return (await this.getHttpClientPromise())?.get(`/questions/${pollId}/options/${optionId}/voters`, {
        ...this.requestOptions,
        params
      }).then((response) => this.fetchData(response));
    };
    this.requestOptions = { baseURL: BASE_URL, headers: { Authorization: instance } };
  }
}
export {
  PollsService
};
//# sourceMappingURL=PollsService.js.map
